<template>
  <v-card-text id="display-files-container">
    <v-container v-if="queries && queries.length > 0" grid-list-md>
      <p class="caption text-xs-right mb-1">{{ $tc('modal.displayFiles.numberOfSearchStrategies', queries.length, {num : queries.length}) }}</p>
      <v-layout align-left wrap class="pa-2 pb-2">
        <template v-for="(item, index) in headings">
          <v-flex
            :key="index"
            xs12
            v-bind="{[`sm${item.width}`]: true}"
            @click="item.provideClick && handleSortClick(item.name)"
            :class="(item.provideClick ? 'sortableColumnHeading' : '') + ' ' + (item.extraClasses ? item.extraClasses : '')"
          ><b>{{item.name.capitalize()}}</b> <v-icon>{{formulateIcon(item.name)}}</v-icon></v-flex>
        </template>
      </v-layout>
      <v-divider id="top-divider"></v-divider>
      <v-container id="display-files-list">
        <v-layout
          align-left
          wrap v-for="query in sortedQueries"
          :key="query._id"
          @click.stop="$emit('confirm', query._id)"
          class="pa-2 pb-2 tds-list-row row-styling"
        >
          <v-flex xs12 sm5>
            {{query.name}}
          </v-flex>
          <v-flex xs12 sm2 overflow-hidden>
            {{formulateSearchName(query)}}
          </v-flex>
          <v-flex xs12 :class="hasActionColumn ? 'sm4' : 'sm5'">
            {{formatDate(query)}}
            <span class="ml-2 blue-grey--text text--lighten-1 caption">{{formatDateRelative(query)}}</span>
          </v-flex>
          <v-flex v-if="hasActionColumn" xs12 sm1 @click.stop="$emit('queryToDeleteId', query)" class="text-xs-right">
            <v-icon>delete</v-icon>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
    <p v-else class="modal-text">{{  $t('modal.displayFiles.noSavedFileMsg') }}</p>
  </v-card-text>
</template>

<script>
import Sugar from 'sugar'
import '../../style/_variables.scss'

export default {
  name: 'display-files',
  components: { Sugar },
  props: ['queries', 'hasActionColumn'],
  data () {
    return {
      showDeleteConfirmationModal: false,
      queryToDelete: null,
      currentSortField: 'name',
      currentSortAscending: true,
      sortedQueries: [...this.queries],
      headings: [
        {name: this.$t('modal.displayFiles.tableHeaders.name'), width: '5', provideClick: true},
        {name: this.$t('modal.displayFiles.tableHeaders.source'), width: '2', provideClick: true},
        {name: this.$t('modal.displayFiles.tableHeaders.date'), width: '4', provideClick: true},
        {name: this.$t('modal.displayFiles.tableHeaders.action'), width: '1', provideClick: false, extraClasses: 'text-xs-right'}
      ]
    }
  },
  watch: {
    queries: function (val, oldVal) {
      this.prepareData()
      this.sortQueries()
    }
  },
  created () {
    Sugar.extend()
  },
  mounted () {
    this.prepareData()
    if (!this.hasActionColumn) {
      this.headings = this.headings.filter(el => el.name !== 'action')
    }
  },
  methods: {
    prepareData () {
      this.sortedQueries = [...this.queries]
      this.sortedQueries.map(x => {
        x.sugarUpdatedAt = Sugar.Date.create(x.updatedAt)
      })
    },
    formatDate (q) {
      if (q && q.updatedAt) {
        return Sugar.Date.format(q.sugarUpdatedAt, '%d %h %y - %X')
      } else {
        return ''
      }
    },
    formatDateRelative (q) {
      if (q && q.updatedAt) {
        return Sugar.Date.relative(q.sugarUpdatedAt)
      } else {
        return ''
      }
    },
    formulateIcon (targetField) {
      if (targetField === this.currentSortField) {
        return this.currentSortAscending ? 'arrow_drop_down' : 'arrow_drop_up'
      } else {
        return ''
      }
    },
    formulateSearchName: function (q) {
      return q && q.defaultSearchName
        ? q.defaultSearchName
        : this.defaultSearchName
    },
    sortQueries () {
      if (typeof this.queries === 'undefined' || this.queries === null || this.queries.length <= 1) {
        return
      }
      const f = this.currentSortField
      this.sortedQueries.sort((a, b) => {
        if (f === 'name') {
          return this.currentSortAscending
            ? a[f].localeCompare(b[f])
            : b[f].localeCompare(a[f])
        } else if (f === 'source') {
          return this.currentSortAscending
            ? this.formulateSearchName(a).localeCompare(this.formulateSearchName(b))
            : this.formulateSearchName(b).localeCompare(this.formulateSearchName(a))
        } else {
          if (a.sugarUpdatedAt.isBefore(b.sugarUpdatedAt)) {
            return this.currentSortAscending ? -1 : 1
          }
          if (a.sugarUpdatedAt.isAfter(b.sugarUpdatedAt)) {
            return this.currentSortAscending ? 1 : -1
          }
          return 0
        }
      })
    },
    handleSortClick (targetField) {
      if (targetField === this.currentSortField) {
        this.currentSortAscending = !this.currentSortAscending
      } else {
        this.currentSortField = targetField
        this.currentSortAscending = true
      }
      this.sortQueries()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#display-files-container {
  height: 50vh;
  overflow: hidden;
  padding: 0;
}
#display-files-list {
  height: 45vh;
  overflow: auto;
}
#top-divider {
  background-color: $grey-800;
}
.row-styling {
  border-bottom: 1px solid $grey-800;
}
.tds-list-row {
  cursor: pointer;
}
.sortableColumnHeading {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/DisplayFiles.vue